export default "__VITE_ASSET__DzH00xKb__"